import React, { Component } from "react";
import {
  NavBar,
  Icon,
  Button,
  WhiteSpace,
  WingBlank,
  Modal,
  Toast,
} from "antd-mobile";
import "./clockin.scss";
import company_sys from "../../assets/images/saoyisao.png";
import moment from "moment";

export class Clockin extends Component {
  state = {};
  DYcamera = () => {
    window.wx.scanQRCode({
      needResult: 1,
      desc: "scanQRCode desc",
      success: (res) => {
        let result = JSON.parse(res.resultStr);
        let date = new Date();
        var beginDiff = date.getTime() - result.expireTime; //时间差的毫秒数
        if (beginDiff < 0) {
          setTimeout(() => {
            this.props.history.push({
              pathname: "/Tdakak/" + result.pointId + "/" + result.pointName
            });
          }, 1000);
        } else {
          alert("打卡失败");
          setTimeout(() => {
            this.props.history.push({
              pathname: "/uploadImg/" + result.pointId + "/" + result.pointName,
            });
          }, 1000);
        }
      },
    });
  };
  render() {
    return (
      <div className="kakaing">
        <NavBar mode="dark">扫码界面</NavBar>
        <div className="saoyisao">
          <h4>请点击扫一扫</h4>
          <img src={company_sys} alt="" onClick={this.DYcamera} />
        </div>
      </div>
    );
  }
}

export default Clockin;
